export const WIKIDATA_URI_PREFIX = "http://www.wikidata.org/entity/";
export function wdIriToNumId(wdIri) {
    return Number(wdIri.split("/").pop().slice(1));
}
export function concatWdPrefixWithId(id) {
    return WIKIDATA_URI_PREFIX + id;
}
export function isWdEntityPropertyDesc(entity) {
    return "datatype" in entity;
}
export function isWdEntityClassDesc(entity) {
    return !("datatype" in entity);
}
//# sourceMappingURL=wd-entity.js.map